import { render } from "./ShareholderASICNonAusCorporate.vue?vue&type=template&id=f668293a&scoped=true&ts=true"
import script from "./ShareholderASICNonAusCorporate.vue?vue&type=script&lang=ts"
export * from "./ShareholderASICNonAusCorporate.vue?vue&type=script&lang=ts"

import "./ShareholderASICNonAusCorporate.vue?vue&type=style&index=0&id=f668293a&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f668293a"]])

export default __exports__